import PropTypes from 'prop-types';

export const linksShape = PropTypes.shape({
  main: PropTypes.string,
  main_relative: PropTypes.string,
  short: PropTypes.string,
});
